import { SheetClose, SheetHeader, SheetTitle } from '@e2n/ui';
import { faArrowLeft } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';

export function CreateTerminKalenderSheetHeader() {
  const { t } = useTranslation();

  return (
    <SheetHeader className="flex flex-row items-baseline gap-2 bg-neutrals-200 p-4">
      <SheetClose>
        <FontAwesomeIcon className="cursor-pointer" icon={faArrowLeft} />
      </SheetClose>
      <SheetTitle className="text-sm text-neutrals-800">
        {t('domain.termine.kalender.form.neuerKalender')}
      </SheetTitle>
    </SheetHeader>
  );
}
